import { MouseEvent } from 'react';
import { IconButton } from '@components/iconButton/IconButton';
import { Star, StarSolid } from '@assets/svgs';

interface IIconFavorite {
  isFavorite: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  sx?: React.CSSProperties;
}

export const IconFavorite = ({ isFavorite, onClick, sx }: IIconFavorite) => {
  if (isFavorite)
    return (
      <IconButton variant='circular' onClick={onClick} sx={{ color: 'secondary.main', ...sx }}>
        <StarSolid width='16px' height='17px' />
      </IconButton>
    );

  return (
    <IconButton variant='circular' onClick={onClick} sx={{ color: 'secondary.main', ...sx }}>
      <Star width='16px' height='17px' />
    </IconButton>
  );
};
